export class DownloadApiError extends Error {
    constructor(status) {
        super('download_request_failed');
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
    }
}
const request = async (path, options = {}) => {
    const response = await fetch(path, {
        ...options,
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
            Accept: 'application/json',
            ...(options.body === undefined ? {} : { 'Content-Type': 'application/json' }),
            ...options.headers
        }
    });
    let data;
    try {
        data = await response.json();
    }
    catch {
        throw new DownloadApiError(response.status || 503);
    }
    if (!response.ok || !data || typeof data !== 'object')
        throw new DownloadApiError(response.status);
    return data;
};
export const downloadsApi = {
    status: () => request('/api/downloads/status.php'),
    access: (code) => request('/api/downloads/access.php', {
        method: 'POST',
        body: JSON.stringify({ code })
    }),
    logout: () => request('/api/downloads/logout.php', {
        method: 'POST',
        body: JSON.stringify({})
    }),
    fileUrl: (id) => `/api/downloads/file.php?file=${encodeURIComponent(id)}`
};
